import CurrencyInput from 'react-currency-input-field'
import { inputVariants } from '../Input'
import { VariantProps } from 'tailwind-variants'

type TInputCurrencyProps = {
  placeholder: string
  value?: string
  onChange: (value: string | undefined) => void
  message?: string
} & VariantProps<typeof inputVariants>

export function InputCurrency({
  value,
  onChange,
  placeholder,
  isInvalid,
  isValid,
  sizes = 'xs',
  variant,
  message,
}: TInputCurrencyProps) {
  const { container, input } = inputVariants({
    isInvalid,
    isValid,
    sizes,
    variant,
  })

  return (
    <div className={container()}>
      <div className="relative w-full">
        <CurrencyInput
          placeholder={placeholder}
          intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
          prefix=" "
          className={input()}
          value={value}
          onValueChange={onChange}
        />
      </div>

      {message && (
        <small
          data-testid="helper_message_input"
          data-invalid={isInvalid}
          className="font-outfit text-xs data-[invalid]:text-danger-500">
          {message}
        </small>
      )}
    </div>
  )
}
